import { Trash } from 'iconsax-react'

import { useLessonMutations } from '@/app/hooks/useLessonMutations'
import { Button } from '@/view/components/ui/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTrigger,
} from '@/view/components/ui/dialog'
import { CircleAlert } from 'lucide-react'
import { useState } from 'react'

interface DeleteLessonProps {
  lessonId: string
}

export const DeleteLesson = ({ lessonId }: DeleteLessonProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const { deleteLessonMutation } = useLessonMutations()

  const handleDelete = async () => {
    try {
      await deleteLessonMutation.mutateAsync(lessonId)
      setIsOpen(false)
    } catch (error) {
      console.error(error)
    }
  }

  const handleOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    setIsOpen(true)
  }

  const handleClose = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    setIsOpen(false)
  }

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger onClick={handleOpen}>
        <Button size="icon" variant="destructive" className="h-11 w-11">
          <Trash size={24} strokeWidth={1.5} />
        </Button>
      </DialogTrigger>

      <DialogContent>
        <div className="flex w-full items-center justify-center">
          <CircleAlert className="text-destructive" size={52} />
        </div>
        <p className="mb-2 text-center text-xl">
          Deseja mesmo deletar essa aula?
        </p>
        <div className="flex justify-end space-x-4">
          <DialogClose onClick={handleClose}>
            <Button
              size="lg"
              onClick={handleDelete}
              className="w-full rounded-full bg-transparent text-primary hover:bg-primary/10"
            >
              Sim, deletar aula
            </Button>
          </DialogClose>
          <DialogClose onClick={handleClose}>
            <Button
              size="lg"
              className="w-full rounded-full bg-primary text-white"
            >
              Não, Cancelar
            </Button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  )
}
